/** @jsxImportSource @emotion/react */
import { Routes, Route, Navigate, useLocation, useSearchParams } from "react-router-dom";
import Login from "./secciones/login/Login";
import NotFound from "./secciones/notFound/NotFound";
import NuevoProceso from "./secciones/proceso/NuevoProceso";
import CertificadoSeleccionado from "./secciones/certificadoSeleccionado/CertificadoSeleccionado";

import GeneradorEtiquetasJuguetes from "./secciones/juguetes/GeneradorEtiquetasJuguetes";
import PropuestaComercial from "./secciones/propuestaComercial/PropuestaComercial";
import PropuestaSabana from "./secciones/propuestaSabana/PropuestaSabana";
import Hallazgo from "./secciones/hallazgo/Hallazgo";
import Facturacion from "./secciones/facturacion/Facturacion";
import Inicio from "./secciones/inicio/Inicio";
import Operaciones from "./secciones/inicio/Operaciones";
import Certificados from "./secciones/certificados/Certificados";
import Procesos from "./secciones/procesos/Procesos";
import DetalleActividad from "./secciones/procesos/DetalleActividad";
import Propuestas from "./secciones/propuestas/Propuestas";
import Hallazgos from "./secciones/hallazgos/Hallazgos";
import MiCuenta from "./secciones/cuenta/MiCuenta";

import { ArchivoPreviewPage, Boton, readFromLS } from "./shared";
import Asistente, { abrirAsistente } from "./secciones/asistente/Asistente";

// Contenedor de cada sección, igual que en el admin
const contenedor = {
  marginLeft: "auto",
  marginRight: "auto",
  maxWidth: "1440px",
  padding: "0px 15px"
};

export default function Router() {
  const [searchParams] = useSearchParams();
  const location = useLocation();

  // Igual que el admin: con oauthtoken en la URL (vuelta del portal público)
  // o en /login, se está iniciando sesión; sin token guardado, también
  const oauthtoken = searchParams.get("oauthtoken");
  const enProcesoDeLogin = oauthtoken || location.pathname === "/login";
  const tieneToken = readFromLS(process.env.REACT_APP_LS_LOGIN_TOKEN);

  if (enProcesoDeLogin || !tieneToken) {
    return (
      <div css={contenedor}>
        <Routes>
          <Route path="/login" element={<Login />} />
          {/* Vista pública de un archivo por su hash: no pide sesión */}
          <Route path="/archivo/:hash" element={<ArchivoPreviewPage />} />
          <Route path="*" element={<Login />} />
        </Routes>
      </div>
    );
  }

  return (
    <>
      <div css={contenedor}>
        {/* Como en el admin: cada cambio de URL monta la sección de nuevo */}
        <Routes key={location.pathname}>
          <Route path="/" element={<Inicio />} />
          <Route path="/login" element={<Login />} />
          {/* "Pendientes" era una pestaña de la barra inferior de mobile: lo mismo
          está en el Inicio */}
          <Route path="/pendientes" element={<Navigate to="/" replace />} />
          <Route path="/certificados" element={<Certificados />} />
          <Route path="/certificado/:certificadoId" element={<CertificadoSeleccionado />} />
          <Route path="/procesos" element={<Procesos />} />
          {/* Ya no hay pantalla de proceso: el portal muestra actividades */}
          <Route path="/procesos/:procesoId" element={<Navigate to="/procesos" replace />} />
          <Route path="/actividades/:actividadId" element={<DetalleActividad />} />
          <Route path="/nuevoproceso" element={<NuevoProceso />} />
          <Route path="/propuestas" element={<Propuestas />} />
          <Route path="/propuesta/:propuestaId" element={<PropuestaComercial />} />
          <Route path="/propuestasabana/:propuestaId" element={<PropuestaSabana />} />
          {/* Ruta vieja del menú "Propuestas activas" */}
          <Route path="/propuestassabana" element={<Navigate to="/propuestas?tab=sabanas" replace />} />
          <Route path="/hallazgos" element={<Hallazgos />} />
          <Route path="/hallazgo/:hallazgoId" element={<Hallazgo />} />
          <Route path="/facturacion" element={<Facturacion />} />
          <Route path="/operaciones" element={<Operaciones />} />
          <Route path="/herramientas" element={<Navigate to="/operaciones" replace />} />
          <Route path="/generadoretiquetasjuguetes" element={<GeneradorEtiquetasJuguetes />} />
          <Route path="/cuenta" element={<MiCuenta />} />
          <Route path="/archivo/:hash" element={<ArchivoPreviewPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      {/* El asistente, en todas las secciones: botón flotante (el mismo que el
          del asistente del admin) y su panel */}
      <div
        css={{
          position: "fixed",
          right: "20px",
          bottom: "20px",
          zIndex: 1001,
          "& .p-button": {
            width: "3.2rem",
            height: "3.2rem",
            padding: 0,
            justifyContent: "center",
            borderRadius: "50%",
            fontSize: "1.3rem",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)"
          }
        }}
      >
        <Boton callback={abrirAsistente}>
          <i className="pi pi-comments"></i>
        </Boton>
      </div>
      <Asistente />
    </>
  );
}
